var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-fieldset', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.kdkantor),
      expression: " isian.kdkantor "
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.kdkantor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "020400"
    }
  }, [_vm._v("020400 - KPU BC Tipe B Batam")])])]), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "<i class='fa fa-align-justify'></i> Pengajuan Izin"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Form Header Perijinan")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Identitas Perijinan")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Identitas"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.perjnid),
      expression: " isian.perjnid "
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disab,
      "title": "Identitas perusahaan"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.perjnid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.identitas), function(id) {
    return _c('option', {
      key: id.kd_id,
      domProps: {
        "value": id.kd_id
      }
    }, [_vm._v("\n                      " + _vm._s(id.URAIAN) + "\n                    ")])
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "No Identitas"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.isian.perjnid === '5' ? 'required|min:16' : 'required'),
      expression: " isian.perjnid === '5' ? 'required|min:16' : 'required' "
    }],
    attrs: {
      "title": "Nomor identitas perusahaan",
      "name": "No Identitas",
      "minlength": "16",
      "maxlength": "16",
      "disabled": _vm.disab,
      "type": "text",
      "placeholder": "No Identitas"
    },
    model: {
      value: (_vm.isian.perid),
      callback: function($$v) {
        _vm.isian.perid = $$v
      },
      expression: " isian.perid "
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No Identitas')),
      expression: " errors.has( 'No Identitas' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('No Identitas')))])], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Nama"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "title": "Nama perusahaan",
      "name": "Nama",
      "disabled": _vm.disab,
      "type": "text",
      "placeholder": "Nama"
    },
    model: {
      value: (_vm.isian.pernama),
      callback: function($$v) {
        _vm.isian.pernama = $$v
      },
      expression: " isian.pernama "
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nama')),
      expression: " errors.has( 'Nama' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Nama')))])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Alamat"
    }
  }, [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.peralamat),
      expression: " isian.peralamat "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Alamat perusahaan",
      "name": "Alamat",
      "rows": "2",
      "disabled": _vm.disab,
      "placeholder": "Alamat"
    },
    domProps: {
      "value": (_vm.isian.peralamat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isian.peralamat = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Alamat')),
      expression: " errors.has( 'Alamat' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Alamat')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "No Permohonan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "title": "Nomor Permohonan Izin",
      "name": "No Permohonan",
      "type": "text",
      "placeholder": "No Permohonan"
    },
    model: {
      value: (_vm.isian.nopermohonan),
      callback: function($$v) {
        _vm.isian.nopermohonan = $$v
      },
      expression: " isian.nopermohonan "
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No Permohonan')),
      expression: " errors.has( 'No Permohonan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('No Permohonan')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tgl Permohonan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "title": "Tanggal Permohonan Izin",
      "name": "Tgl Permohonan",
      "type": "date"
    },
    model: {
      value: (_vm.isian.tglpermohonan),
      callback: function($$v) {
        _vm.isian.tglpermohonan = $$v
      },
      expression: " isian.tglpermohonan "
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tgl Permohonan')),
      expression: " errors.has( 'Tgl Permohonan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('Tgl Permohonan')))])], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Perijinan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "list": _vm.jnijin,
      "option-value": "id_ijin",
      "option-text": "nama_ijin",
      "name": "Jenis Perizinan",
      "placeholder": "-- Pilih Jenis Perijinan --"
    },
    model: {
      value: (_vm.isian.jnperijinan),
      callback: function($$v) {
        _vm.isian.jnperijinan = $$v
      },
      expression: " isian.jnperijinan "
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Perizinan')),
      expression: " errors.has( 'Jenis Perizinan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Perizinan')))])], 1), _vm._v(" "), (_vm.isian.jnperijinan === 5 || _vm.isian.jnperijinan === 4) ? _c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Dokumen"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.jnsdok),
      expression: " isian.jnsdok "
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Jenis Dokumen Yang Diajukan",
      "name": "Jenis PPFTZ"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.jnsdok = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Jenis Dokumen")]), _vm._v(" "), _vm._l((_vm.jenisPpftz), function(ppftz) {
    return _c('option', {
      domProps: {
        "value": ppftz.value
      }
    }, [_vm._v("\n                  " + _vm._s(ppftz.text) + "\n                ")])
  })], 2), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis PPFTZ')),
      expression: " errors.has( 'Jenis PPFTZ' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis PPFTZ')))])]) : _vm._e(), _vm._v(" "), (_vm.isian.jnperijinan === 23) ? _c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Dokumen yang akan dibatalkan"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.jnsdok),
      expression: " isian.jnsdok "
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Jenis Dokumen Yang Diajukan",
      "name": "Jenis Manifes"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.jnsdok = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Jenis Dokumen")]), _vm._v(" "), _vm._l((_vm.jenisManifes), function(manifes) {
    return _c('option', {
      domProps: {
        "value": manifes.value
      }
    }, [_vm._v("\n                  " + _vm._s(manifes.text) + "\n                ")])
  })], 2), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Manifes')),
      expression: " errors.has( 'Jenis Manifes' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Manifes')))])]) : _vm._e(), _vm._v(" "), (_vm.isian.jnperijinan === 3) ? _c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Pembongkaran"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.jnsdok),
      expression: " isian.jnsdok "
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "",
      "name": "Jenis Pembongkaran"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.jnsdok = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Jenis Pembongkaran")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Non Ship to Ship")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Ship to Ship")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Pembongkaran')),
      expression: " errors.has( 'Jenis Pembongkaran' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Jenis Pembongkaran')) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.isian.jnperijinan === 45) ? _c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Usaha"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.jnsNppbkc),
      expression: " isian.jnsNppbkc "
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "",
      "name": "Jenis Usaha"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.jnsNppbkc = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Jenis Usaha")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Tempat Penjualan Eceran MMEA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Distributor MMEA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Lainnya")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Usaha')),
      expression: " errors.has( 'Jenis Usaha' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Jenis Usaha')) + "\n              ")])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Identitas Pemohon Izin")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Identitas"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.ppjkjnid),
      expression: " isian.ppjkjnid "
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.ppjkjnid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.identitas), function(id) {
    return _c('option', {
      key: id.kd_id,
      domProps: {
        "value": id.kd_id
      }
    }, [_vm._v("\n                      " + _vm._s(id.URAIAN) + "\n                    ")])
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "No Identitas"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": true,
      "type": "text",
      "placeholder": "No Identitas",
      "maxlength": "16"
    },
    model: {
      value: (_vm.isian.ppjkid),
      callback: function($$v) {
        _vm.isian.ppjkid = $$v
      },
      expression: " isian.ppjkid "
    }
  })], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Nama"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": true,
      "type": "text"
    },
    model: {
      value: (_vm.isian.ppjknama),
      callback: function($$v) {
        _vm.isian.ppjknama = $$v
      },
      expression: " isian.ppjknama "
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Alamat"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.ppjkalamat),
      expression: " isian.ppjkalamat "
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.isian.ppjkalamat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isian.ppjkalamat = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "No HP / Telepon"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:15|min:3'),
      expression: " 'required|max:15|min:3' "
    }],
    attrs: {
      "title": "Nomor HP Yang Dapat Dihubungi",
      "name": "No Telepon",
      "type": "text",
      "placeholder": "No HP / Telepon"
    },
    model: {
      value: (_vm.isian.notelp),
      callback: function($$v) {
        _vm.isian.notelp = $$v
      },
      expression: " isian.notelp "
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No Telepon')),
      expression: " errors.has( 'No Telepon' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('No Telepon')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Email"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: " 'required|email' "
    }],
    attrs: {
      "title": "Email Yang Dapat Dihubungi",
      "name": "Email",
      "type": "text",
      "placeholder": "Email"
    },
    model: {
      value: (_vm.isian.email),
      callback: function($$v) {
        _vm.isian.email = $$v
      },
      expression: " isian.email "
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Email')),
      expression: " errors.has( 'Email' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Email')))])], 1)], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4",
    attrs: {
      "title": "Simpan Header Permohonan Izin",
      "type": "submit",
      "name": "button"
    },
    on: {
      "click": _vm.savePermohonan
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-secondary pull-right",
    attrs: {
      "to": '/pengajuan'
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply"
  }), _vm._v(" Back\n          ")])], 1)])], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27c8c451","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Pengajuan/AddHeader.vue
// module id = 184
// module chunks = 0